import React from 'react'
import { Modal, Button } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'

const BreakdownDashboardHelpModal = ({ visible, onClose }) => {
  const apiUrl = process.env.REACT_APP_API_URL || ''
  const downloadPdfUrl = `${apiUrl}${apiUrl && !apiUrl.endsWith('/') ? '/' : ''}download_summary_pdf?module=breakdown-dashboard`

  return (
    <Modal
      title={
        <div className='breakdown-dash-help-header'>
          <span className='breakdown-dash-help-header-title'>Breakdown Dashboard Summary</span>
        </div>
      }
      open={visible}
      visible={visible}
      onCancel={onClose}
      centered
      footer={[
        <a key='download' href={downloadPdfUrl} download='Breakdown Dashboard summary.pdf'>
          <Button type='primary' className='breakdown-dash-help-download-btn' icon={<DownloadOutlined />}>
            Download PDF
          </Button>
        </a>
      ]}
      width={780}
      className='custom-modal breakdown-dash-help-modal'
    >
      <div className='breakdown-dash-help-content'>
        <div className='breakdown-dash-help-card'>
          <div className='breakdown-dash-help-title'>Breakdown Dashboard</div>
          <p>
            The Breakdown Dashboard displays all shipments waiting for Breakdown in the selected Work Area. It displays the ULD number, along with the AWBs in the ULD, the last scanned location of the ULD, the remaining handling time , the piece count and the destination of the ULD. Based on the handling time remaining, the countdown timer could be green, red or amber. <span className='breakdown-dash-text-green'>Green</span> colour would mean that the handling time remaining is sufficient, <span className='breakdown-dash-text-amber'>amber</span> colour is set once the countdown crosses the amber threshold set on the Handling times page, and <span className='breakdown-dash-text-red'>red</span> is set once the Handling time elapses.
          </p>
        </div>

        <div className='breakdown-dash-help-card'>
          <div className='breakdown-dash-help-title'>Conditions to Add</div>
          <p>
            The Breakdown dashboard is a mirror of the breakdown control screen for a particular work area. Once a shipment is added on the control screen it will appear on the dashboard. Shipments are added once the Hub Control System receives a RCF message and is scanned to a location mapped for breakdown.
          </p>
        </div>

        <div className='breakdown-dash-help-card'>
          <div className='breakdown-dash-help-title'>Conditions to Remove</div>
          <ul className='breakdown-dash-help-list'>
            <li>
              Once all AWBs in the ULD has been broken-down it will be taken off the Dashboard.
            </li>
            <li>
              For local shipments, once the NFD or DLV message is received it will be taken off the dashboard.
            </li>
            <li>
              Marking an AWB as complete using the &apos;Mark-as-complete&apos; checkbox on the Breakdown-Control screen takes the AWB off the Dashboard.
            </li>
            <li>
              If the countdown for an AWB elapses then the AWB will be taken off the dashboard. This is because by default the filters applied only displays AWBs having 1 minute or more handling time remaining.
            </li>
          </ul>
        </div>

        <div className='breakdown-dash-help-card'>
          <div className='breakdown-dash-help-title'>Order by</div>
          <p>
            By default the ULDs/AWBs are ordered by the handling time remaining, with the least handling time appearing at the top.
          </p>
        </div>

        <div className='breakdown-dash-help-card'>
          <div className='breakdown-dash-help-title'>Filters</div>
          <p>
            By default the Breakdown Dashboard displays ULDs which have 1 minute or more of handling time. In addition to this, the list can be filtered by Work-area; type - whether local, transit or all; product code, location and cargo - whether BLK, SLU, PTU or ULD. Also, certain product codes can be completely excluded from the list using the exclusion filter.
          </p>
        </div>

        <div className='breakdown-dash-help-card'>
          <div className='breakdown-dash-help-title'>Comments</div>
          <p>
            <strong>Countdown Timer :</strong> The Handling time is calculated from the parameters set in the Handling Time screen of System Parameters module -
          </p>
          <ul className='breakdown-dash-help-list mb-2'>
            <li>
              <strong>1) Local &ndash;</strong> for local shipments the handling time is 1-AC OFF + 2TFR TO WH + 3BD &amp; STORE
            </li>
            <li>
              <strong>2) For Transit &ndash;</strong> the handling time is taken as the connection time minus the FPE value for that product code/process combination.
            </li>
          </ul>
          <p>
            For the Hub Control perspective, there is no differentiation between final rack location and permanent locations. The Breakdown module works with the locations added in the Breakdown Work Area mapping page. Once a shipment is scanned to these location, the same will appear on the Breakdown module. When the scanned location is not in the Breakdown Work Area mapping, then the AWB will be removed from the display.
          </p>
        </div>
      </div>
    </Modal>
  )
}

export default BreakdownDashboardHelpModal
